import Echo from 'laravel-echo';

export function sanitizeVehicleRegNumber(regNumber) {
  // Remove: space, minus, dash and underscore
  return regNumber.replace(/\s|-|–|_/g, '');
}

export function connectEcho() {
  const URL = process.env.BACKEND_API_URL.match(/((?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9])|((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))|(localhost)/g)[0];
  return new Echo({
    broadcaster: 'pusher',
    key: process.env.VUE_APP_WEBSOCKETS_KEY,
    wsHost: window.location.hostname,
    wsPort: 6001,
    wssPort: 6001,
    forceTLS: process.env.FORCE_TLS,
    disableStats: true,
    encrypted: true,
    authEndpoint: `http://${URL}/admin/admin/auth`,
    enabledTransports: ['ws', 'wss'],
    auth: {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('id_token')}`,
        "X-App-ID": '123',
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/utils.js